module.exports = __webpack_public_path__ + "img/myguard_pro_02.61aeb0e4.png";